module.exports = __webpack_public_path__ + "img/tree-05-d-trunk.129b5925.png";